import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=fca4099c&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fca4099c')) {
      api.createRecord('fca4099c', component.options)
    } else {
      api.reload('fca4099c', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=fca4099c&", function () {
      api.rerender('fca4099c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qHdDVjYNwbVK/JS/comp/ErrorMessage.vue"
export default component.exports